import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function usePostScheduleTours() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [data, setData] = useState(null);

  const scheduleTours = async (toursPlanningIds, deliveryDate) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.post(`/tours-planning/schedule`, {
        tours_planning_ids: toursPlanningIds,
        delivery_date: deliveryDate,
      });
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (response.status === 200) {
        setIsSuccess(true);
        setData(response.data);
        toast.success(
          response.data?.message || 'Tournées planifiées avec succès.'
        );
      } else {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      toast.error(error?.response?.data?.message || error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setIsSuccess(false);
    setIsLoading(false);
    setData(null);
  };

  return {
    isLoading,
    isSuccess,
    data,
    scheduleTours,
  };
}

